/* eslint-disable react/no-array-index-key */
import React from 'react';
import SVGComponent from '../../../components/SVG/SVGComponent';
import { SVG_ICONS } from '../../../constants';

const TeamsPreference = ({
  selectTeamPreference, toggleTeamsDropdown, addTeamPreference, disabledCheck,
  filteredTeams, changeTeam, removeTeam, league, currentLeague,
}) => (
  <div className="col-sm-7 m-t-20 dialog__league-option">
    <label className="checkbox">
      <input
        id={`random-matches-${league.name}`}
        type="checkbox"
        className="pref-check"
        onChange={selectTeamPreference.bind(this, league)}
        checked={!!(currentLeague && currentLeague.preferredTeams)}
      />
      <div className="checkbox__icon m-r-20" />
      <span className="checkbox__label">Team preference</span>
    </label>
    <div className="team-pref">
      <div className="team-pref__list">
        {currentLeague && currentLeague.preferredTeams
                    && currentLeague.preferredTeams.map((teamPreference, index) => (
                      <div className="team-pref__list-item m-t-10" key={`team-pref_${index}`}>
                        <div className="dialog__input-wrap">
                          <div
                            className={`dialog__input dialog__input--select ${teamPreference.opened ? 'open' : ''}`}
                            onClick={toggleTeamsDropdown.bind(this, league, index)}
                          >
                            <span>{teamPreference.name}</span>
                          </div>
                          <div className="dialog__input-dropdown">
                            <div className="dialog__input-list">
                              {filteredTeams(league.teams, currentLeague.preferredTeams)
                                .map((team) => (
                                  <div
                                    className="dialog__input-list-item"
                                    key={team.name}
                                    onClick={changeTeam.bind(this, league, team, index)}
                                  >
                                    {team.name}
                                  </div>
                                ))}
                            </div>
                          </div>
                        </div>
                        <div className="team-pref__list-item-btn">
                          <SVGComponent
                            src={`${SVG_ICONS.utility}#bin`}
                            className="icon-xxs m-l-5"
                            onClick={removeTeam.bind(this, league, index)}
                          />
                        </div>
                      </div>
                    ))}
      </div>
      <div
        className={`team-pref__btn m-t-10 ${currentLeague && currentLeague.preferredTeams ? 'is-visible' : ''}`}
        onClick={addTeamPreference.bind(this, league)}
        disabled={disabledCheck(currentLeague)}
      >
        <span className="m-r-15">+</span>
        Add Team
      </div>
    </div>
  </div>
);

export default TeamsPreference;
